export const STUDIO_ASSISTANT_GUIDES = [
  {
    id: "studio-journey",
    title: "Jornadas guiadas",
    summary:
      "Sequência de perguntas que coleta objetivos, stakeholders, SLAs e regras de negócio para gerar processo e formulário.",
    keywords: ["studio", "assistente", "jornada", "questionario"],
    highlights: [
      "Mantém progresso entre sessões e permite retomar de onde parou.",
      "Aplica variações de perguntas automaticamente para sair do bloqueio criativo.",
    ],
  },
  {
    id: "studio-assets",
    title: "Geração de artefatos",
    summary:
      "Entrega formulário estruturado, passos BPMN, SLAs sugeridos e insights de automação em um único resumo.",
    keywords: ["artefatos", "bpmn", "formulario", "insights"],
    highlights: [
      "Sugere grupos e campos adicionais com base em memórias anteriores do usuário.",
      "Disponibiliza atalhos para salvar automaticamente formulário e processo como rascunhos.",
    ],
  },
  {
    id: "studio-handoff",
    title: "Integração com outros módulos",
    summary:
      "Os resultados do Studio alimentam diretamente Formulários, Processos e notificações operacionais.",
    keywords: ["integracao", "formularios", "processos", "handoff"],
    highlights: [
      "Os campos sugeridos podem ser abertos no Form Builder com mapeamento de grupos e validações.",
      "Os processos gerados herdam responsáveis e prazos identificados pela IA, facilitando publicação rápida.",
    ],
  },
];
